import { useEffect, useState } from 'react';
import API from '../utils/api';

export default function PromotionAnalytics() {
  const [promotions, setPromotions] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAnalytics = async () => {
      try {
        const res = await API.get('/promotions/seller/analytics');
        setPromotions(res.data.promotions);
      } catch (err) {
        console.error('Failed to fetch promotion analytics:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchAnalytics();
  }, []);

  if (loading) {
    return <div style={{ padding: 20, textAlign: 'center' }}>Loading...</div>;
  }

  if (promotions.length === 0) {
    return (
      <div style={{ padding: 32, textAlign: 'center', background: 'var(--cream)', borderRadius: 12, marginTop: 20 }}>
        <p style={{ color: 'var(--text-soft)', marginBottom: 12 }}>
          You don't have any active promotions yet
        </p>
        <p style={{ fontSize: 12, color: 'var(--text-soft)' }}>
          Boost your listings to get more visibility!
        </p>
      </div>
    );
  }

  return (
    <div style={{ marginTop: 24 }}>
      <h3 style={{ fontSize: 16, fontWeight: 700, marginBottom: 16 }}>
        📊 Active Promotions
      </h3>

      <div style={{ display: 'grid', gap: 12 }}>
        {promotions.map(promo => {
          const hoursRemaining = Math.round(promo.hours_remaining);
          const daysRemaining = Math.floor(hoursRemaining / 24);
          const minsRemaining = Math.round((hoursRemaining % 1) * 60);

          let timeLabel = '';
          if (daysRemaining > 0) {
            timeLabel = `${daysRemaining}d ${hoursRemaining % 24}h remaining`;
          } else if (hoursRemaining > 0) {
            timeLabel = `${hoursRemaining}h remaining`;
          } else {
            timeLabel = 'Expiring soon';
          }

          const tierLabels = {
            basic: '🥉 Basic',
            premium: '🥈 Premium',
            vip: '🥇 VIP'
          };

          return (
            <div
              key={promo.id}
              style={{
                padding: 16,
                border: '1px solid var(--border)',
                borderRadius: 12,
                background: 'white'
              }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 12 }}>
                <div>
                  <h4 style={{ fontSize: 14, fontWeight: 700, marginBottom: 4 }}>
                    {promo.title}
                  </h4>
                  <p style={{ fontSize: 12, color: 'var(--text-soft)' }}>
                    {tierLabels[promo.tier]} · ${promo.price}
                  </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <div style={{ fontSize: 11, color: 'var(--text-soft)', marginBottom: 4 }}>
                    {timeLabel}
                  </div>
                  <div style={{
                    display: 'inline-block',
                    padding: '4px 10px',
                    background: 'var(--cherry-light)',
                    color: 'var(--cherry)',
                    borderRadius: 6,
                    fontSize: 11,
                    fontWeight: 700
                  }}>
                    ACTIVE
                  </div>
                </div>
              </div>

              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: 12,
                paddingTop: 12,
                borderTop: '1px solid var(--border)'
              }}>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--cherry)', marginBottom: 4 }}>
                    {promo.impressions}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--text-soft)' }}>
                    Views
                  </div>
                </div>
                <div style={{ textAlign: 'center' }}>
                  <div style={{ fontSize: 20, fontWeight: 700, color: 'var(--cherry)', marginBottom: 4 }}>
                    {promo.clicks}
                  </div>
                  <div style={{ fontSize: 11, color: 'var(--text-soft)' }}>
                    Clicks
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
